/** @format */

import type { PdfContentTree } from "./types";

const URL_REVOKE_DELAY_MS = 1000;

export const toFilename = (title: string): string =>
	title
		.toLocaleLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "") || "question-bank-test";

const downloadBlob = (blob: Blob, downloadName: string): void => {
	const url = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.download = downloadName;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	setTimeout(() => URL.revokeObjectURL(url), URL_REVOKE_DELAY_MS);
};

export const downloadPdf = async (tree: PdfContentTree, downloadName: string): Promise<void> => {
	const [{ pdf }, { PdfExport }, { prerenderMath }, { MathAssetsContext }] = await Promise.all([
		import("@react-pdf/renderer"),
		import("./PdfExport"),
		import("./pdf/renderMath"),
		import("./pdf/mathAssets"),
	]);
	const mathAssets = await prerenderMath(tree);
	const blob = await pdf(
		<MathAssetsContext.Provider value={mathAssets}>
			<PdfExport {...tree} />
		</MathAssetsContext.Provider>,
	).toBlob();
	downloadBlob(blob, downloadName);
};

/**
 * Fetch a file from a URL and trigger a browser download. Used to bundle a
 * paper's existing PDF attachments alongside the generated paper.
 */
export const downloadUrl = async (url: string, downloadName: string): Promise<void> => {
	const response = await fetch(url, { headers: { Accept: "application/pdf,*/*" } });
	if (!response.ok) {
		throw new Error(`Failed to download ${downloadName}`);
	}
	const blob = await response.blob();
	downloadBlob(blob, downloadName);
};
